import React from 'react';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import { getDisplayAddress } from '../../../routes/significantPeopleSection/getAddressHistory';

const ShowAddress = ({ type, value, onEditClick }) => (
  <Content>
    {content => (
      <Field name={`${type}chosenAddressField`}>
        {() => (
          <>
            <Field name={`${type}chosenAddressField`} value={value}>
              {({ input }) => (
                <GenericDescriptionList
                  items={[{ key: content.choosenAddress, value: getDisplayAddress(value) }]}
                />
              )}
            </Field>

            <NavigationButton.Tertiary
              labelText={content.editButtonLabel}
              onClick={e => {
                e.preventDefault();
                onEditClick();
              }}
            />
          </>
        )}
      </Field>
    )}
  </Content>
);

ShowAddress.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.object
};

export default ShowAddress;
